import ApiService from "@/api";
import Toast from "@/common/toast";

const resource = "level";
const resourceValidation = "level/validation";

const LevelService = {
    async get(slug) {
        return ApiService.get(resource, slug);
    },
    async query(params) {
        return ApiService.query(resource, params);
    },
    async create(params) {
        let promise = null;
        try {
            promise = await ApiService.post(resourceValidation, params);
        } catch (e) {
            Toast.showSaveErrorToastI18n(null, e);
        }
        return promise;
    },
    async update(slug, params) {
        let promise = null;
        try {
            promise = await ApiService.put(resource, params);
            Toast.showSaveOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n(null, e);
        }
        return promise;
    },
    async delete(slug) {
        let promise = null;
        try {
            promise = await ApiService.delete(resource, slug);
            // Toast.showDeleteOkToastI18n();
        } catch (e) {
            // Toast.showDeleteErrorToastI18n();
        }
        return promise;
    }
};

export default LevelService;
